import { registerSW } from 'virtual:pwa-register';

// Service-worker registration. With registerType: 'autoUpdate' this module
// reloads the page automatically once a new service worker takes control, so
// open tabs pick up deployments without a manual refresh.
//
// Browsers throttle automatic SW update checks to once every 24h, so poll
// hourly: registration.update() bypasses that throttle. It still honours the
// HTTP cache for sw.js, which is why sw.js must be served with
// Cache-Control: no-cache (configured on the Render static site).
//
// In dev this is a no-op stub — devOptions.enabled is false in vite.config.ts.
registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    registration && setInterval(() => registration.update(), 60 * 60 * 1000);
  },
});
